export const breakpoints = {
  default: '1px',
  xs: '480px',
  sm: '768px',
  md: '992px',
  desktop: '1024px',
  lg: '1200px',
};

export const deviceBreakpoints = {
  default: {
    min: '1px',
    max: '9999px',
  },
  mobile: {
    min: '1px',
    max: '1024px',
  },
  smallDesktop: {
    min: '1024px',
    max: '1310px',
  },
  desktop: {
    min: '1024px',
    max: '5200px',
  },
};

export const fontFamily = {
  //prettier-ignore
  primary:  '\'IBM Plex Sans\', sans-serif',
  old: 'IBMPlexSans',
};

export const colors = {
  theme: {
    primary: '#2F2F2F',
    primary_light: '#FF7828',
    action: '#FF7828',
    cancel: '#d6d6d6',
    danger: '#ff483b',
    grey: '#636262',
    darkGrey: '#434242',
    white: '#ffffff',
    primary_white: '#fff',
  },
  elements: {
    primary: '#FF7828',
    inputs: '#FF7828',
    border: '#FDF2EB',
    danger: '#ff483b',
  },
};
